import HelpResolutionButtons from 'app/components/pages/HelpResolutionButtons'
import ContactUnified from '../app/components/pages/ContactUnified.vue'

window.addEventListener('DOMContentLoaded', function () {
  window.waAdditionalComponents = {
    ContactUnified,
    HelpResolutionButtons
  }
})
